import { reopenTicket } from "@services/api";
import { store } from "@store";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";

const payload = (message) => ({
  shouldShow: true,
  message,
  position: "bottom",
  bottom: 0,
  autoHidingTime: 3000,
  autoHide: true,
  actionText: "Okay",
  actionHandler: (e) => {
    store.dispatch(snackbarActions.hideSnackbar());
  },
});

const reopenSupportTicket =
  (type, ticket_id, cf_issue_level_1) => async (cb) => {
    if (type === "cancel") {
      analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_REOPENED, {
        type: cf_issue_level_1.toString().toLowerCase(),
        selected: "no",
      });

      if (cb && typeof cb === "function") cb();
      store.dispatch(
        snackbarActions.showSnackbar(
          payload("आपकी दी हुई रेटिंग सफलतापूर्वक सब्मिट कर ली गयी है  |"),
        ),
      );
      setTimeout(() => {
        store.dispatch(snackbarActions.hideSnackbar());
      }, 3000);
    } else if (type === "okay") {
      try {
        const { data } = await reopenTicket({ ticket_id });
        analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_REOPENED, {
          type: cf_issue_level_1.toString().toLowerCase(),
          selected: "yes",
        });
        if (cb && typeof cb === "function") cb();

        store.dispatch(
          snackbarActions.showSnackbar(
            payload("आपका टिकट reopen कर दिया है |"),
          ),
        );
        setTimeout(() => {
          store.dispatch(snackbarActions.hideSnackbar());
        }, 3000);
      } catch (err) {
        //setShowReopenModal(false);
        if (cb && typeof cb === "function") cb();
      }
    }
  };

export default reopenSupportTicket;
